if (!customElements.get("product-recommendations")){
  class ProductRecommendations extends HTMLElement {
    observer = undefined;
    idleCallback = undefined;
    preloadTimer = undefined;
    isLoading = false;
    isLoaded = false;

    constructor() {
      super();
    }

    connectedCallback() {
      this.initializeRecommendations(this.dataset.productId);
    }

    initializeRecommendations(productId) {
      this.observer?.unobserve(this);

      const load = () => {
        if (this.isLoading || this.isLoaded) return;

        this.observer?.unobserve(this);
        if (this.idleCallback !== undefined && "cancelIdleCallback" in window) {
          window.cancelIdleCallback(this.idleCallback);
        }
        if (this.preloadTimer !== undefined) {
          window.clearTimeout(this.preloadTimer);
        }

        this.loadRecommendations(productId);
      };

      this.observer = new IntersectionObserver(
        (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);
          load();
        },
        { rootMargin: "0px 0px 1600px 0px" }
      );
      this.observer.observe(this);

      const preload = () => {
        if ("requestIdleCallback" in window) {
          this.idleCallback = window.requestIdleCallback(load, { timeout: 1200 });
        } else {
          this.preloadTimer = window.setTimeout(load, 800);
        }
      };

      if (document.readyState === "complete") {
        preload();
      } else {
        window.addEventListener("load", preload, { once: true });
      }
    }

    loadRecommendations(productId) {
      this.isLoading = true;

      fetch(
        `${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`,
        { credentials: "same-origin" }
      )
        .then((response) => {
          if (!response.ok) throw new Error(`Product recommendations request failed: ${response.status}`);
          return response.text();
        })
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations?.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (this.classList.contains("complementary-products")) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }

          this.isLoaded = true;
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.isLoading = false;
        });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      if (this.idleCallback !== undefined && "cancelIdleCallback" in window) {
        window.cancelIdleCallback(this.idleCallback);
      }
      if (this.preloadTimer !== undefined) {
        window.clearTimeout(this.preloadTimer);
      }
    }
  }
  
  customElements.define("product-recommendations", ProductRecommendations);
}
